/**
 * The multi-colored Google "G" mark — inline SVG so consumers don't need a
 * runtime asset. Required by Google's branding guidelines whenever a
 * "Continue with Google" entry point is presented.
 */
export function GoogleGlyph({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill="#4285F4"
        d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.44c-.28 1.48-1.12 2.73-2.38 3.57v2.97h3.85c2.25-2.08 3.58-5.14 3.58-8.78z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.95-1.08 7.93-2.92l-3.85-2.97c-1.07.72-2.43 1.16-4.08 1.16-3.14 0-5.8-2.12-6.75-4.97H1.27v3.12C3.26 21.3 7.31 24 12 24z"
      />
      <path
        fill="#FBBC05"
        d="M5.25 14.3A7.22 7.22 0 0 1 4.86 12c0-.8.14-1.58.39-2.3V6.58H1.27A11.98 11.98 0 0 0 0 12c0 1.94.46 3.77 1.27 5.42l3.98-3.12z"
      />
      <path
        fill="#EA4335"
        d="M12 4.76c1.77 0 3.35.61 4.6 1.81l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.27 6.58l3.98 3.12C6.2 6.88 8.86 4.76 12 4.76z"
      />
    </svg>
  );
}
